'use es6';

import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EPUndoRedoButtons from 'editor-components/header/EPUndoRedoButtons';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { undoModuleReducerChange, redoModuleReducerChange } from 'ContentEditorUI/redux/actions/undoRedoActions';
import { getCanRedoModules, getCanUndoModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIframeReady } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { selectCanUndoInstanceEditingState, selectCanRedoInstanceEditingState } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const UndoRedoButtonWrapper = styled.div.withConfig({
  displayName: "UndoRedoButtonContainer__UndoRedoButtonWrapper",
  componentId: "sc-1e4me1x-0"
})(["button{line-height:16px;}"]);
const canPerformUndoAction = createSelector([getCanUndoModules, selectCanUndoInstanceEditingState, getIsDataAuthoringModeActive], (canUndoModules, canUndoInstanceEditingState, isDataAuthoringModeActive) => {
  if (isDataAuthoringModeActive) {
    return canUndoInstanceEditingState;
  }
  return canUndoModules;
});
const canPerformRedoAction = createSelector([getCanRedoModules, selectCanRedoInstanceEditingState, getIsDataAuthoringModeActive], (canRedoModules, canRedoInstanceEditingState, isDataAuthoringModeActive) => {
  if (isDataAuthoringModeActive) {
    return canRedoInstanceEditingState;
  }
  return canRedoModules;
});
const UndoRedoButtonContainer = ({
  className,
  disabled,
  isVisible,
  buttonStyleOverride,
  tooltipPlacement
}) => {
  const dispatch = useDispatch();
  const canRedo = useSelector(canPerformRedoAction);
  const canUndo = useSelector(canPerformUndoAction);
  const iframeReady = useSelector(getIframeReady);
  function handleRedo() {
    dispatch(redoModuleReducerChange());
  }
  function handleUndo() {
    dispatch(undoModuleReducerChange());
  }
  return /*#__PURE__*/_jsx(UndoRedoButtonWrapper, {
    children: /*#__PURE__*/_jsx(EPUndoRedoButtons, {
      buttonGroupClassName: classNames(className, !isVisible && "hidden"),
      buttonUse: "tertiary-light",
      canRedo: canRedo,
      canUndo: canUndo,
      disabled: disabled || !iframeReady,
      onRedo: handleRedo,
      onUndo: handleUndo,
      tooltipPlacement: tooltipPlacement,
      buttonStyleOverride: buttonStyleOverride,
      usageTracker: UsageTracker.getCachedClonedTracker('editorComponents')
    })
  });
};
UndoRedoButtonContainer.propTypes = {
  className: PropTypes.string,
  tooltipPlacement: PropTypes.oneOf(['left', 'right', 'top', 'bottom', 'left top', 'left bottom', 'right top', 'right bottom', 'top left', 'top right', 'bottom left', 'bottom right']),
  disabled: PropTypes.bool,
  isVisible: PropTypes.bool,
  buttonStyleOverride: PropTypes.object
};
export default UndoRedoButtonContainer;